import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";

export const hawoCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			configuratorEnabled: true,
			surveysEnabled: true,
			projectEnabled: false,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
		workspacesEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
} as const;
